import type { RouteRecordRaw } from 'vue-router'

export const tradingRoutes: RouteRecordRaw = {
  path: '/:lang?/trade-with-us/',
  props: (route) => ({ lang: route.params.lang || 'en' }),
  component: () => import('@/Trading/layouts/DefaultLayout.vue'),
  children: [
    {
      path: '',
      name: 'trading-overview',
      component: () => import('@/Trading/views/BalanceGuard/BalanceGuard.vue'),
      meta: {
        breadcrumbLabel: { parent: 'Trading', child: '_Hantec Balance Guard' },
        breadcrumbRoute: 'trade-with-us/'
      }
    },
    {
      path: 'balanceguard/',
      name: 'balanceguard',
      component: () => import('@/Trading/views/BalanceGuard/BalanceGuard.vue'),
      meta: {
        breadcrumbLabel: { parent: 'Trading', child: '_Hantec Balance Guard' },
        breadcrumbRoute: 'trade-with-us/'
      }
    },
    {
      path: 'pamm/',
      name: 'pamm',
      component: () => import('@/Trading/views/MamPam/MamPam.vue'),
      meta: {
        breadcrumbLabel: { parent: 'Trading', child: 'Hantec PAMM' },
        breadcrumbRoute: 'trade-with-us/'
      }
    },
    {
      path: 'funding-account/',
      name: 'funding-account',
      component: () => import('@/Trading/views/FundingAccount/FundingAccount.vue'),
      meta: {
        breadcrumbLabel: { parent: 'Trading', child: 'Funding your account' },
        breadcrumbRoute: 'trade-with-us/'
      }
    }
  ]
}
